/**
 * Eine Position ist die Zeile, die später im Angebot steht:
 * Leistung, Ort, Menge – dazu Notiz und Fotos.
 *
 * Sie ersetzt die frühere Kette Bereich → Aufmaß → Fläche.
 */
export const EINHEITEN = ['m2', 'stk', 'psch'];
export const EINHEIT_LABELS = {
    m2: 'm²',
    stk: 'Stück',
    psch: 'pauschal',
};
/** Wie die Menge zustande kam. `null` = direkt eingetippt. */
export const RECHENARTEN = ['flaeche', 'raum', 'giebel'];
export const RECHENART_LABELS = {
    flaeche: 'Fläche',
    raum: 'Raum',
    giebel: 'Giebel',
};
//# sourceMappingURL=position.js.map